<template>
  <div>
    <v-card class="ma-2 text-center">
      <v-card-title>
        NBA Fantasy Player Props

        <v-spacer></v-spacer>
        <v-col cols="12" md="4" sm="5">
          <v-row justify="center" align="center">
            <small>Confidence :</small> <br/>&nbsp;
            <v-col class="light-green caption text-center"
            ><span>Low </span></v-col
            >
            <v-col class="medium-green caption text-center"
            ><span>Medium </span></v-col
            >
            <v-col class="dark-green caption text-center"
            ><span>High </span></v-col
            >
          </v-row>
        </v-col>
        <v-spacer></v-spacer>

        <v-col cols="12" md="5" sm="3">
          <v-row align="center" justify="end">
            <v-col md="7" cols="7" sm="6">
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search Player"
                  single-line
                  dense
                  outlined
                  hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="5" md="4" sm="3">
              <v-card-actions>
                <v-switch v-model="switch1" inset label="Props"></v-switch>
                <!-- <v-switch
            class="px-2"
            v-model="switch2"
            :disabled="switch1 ? false : true"
            inset
            label="Confidence"
            @change="enableConfidence"
          ></v-switch> -->
              </v-card-actions>
            </v-col>
          </v-row>
        </v-col>
      </v-card-title>

      <v-data-table
          :headers="computedHeaders"
          :items="projectionItems"
          :items-per-page="10"
          class="elevation-1 projection-table"
          mobile-breakpoint="0"
          calculate-widths
          sort-by="Name"
          :search="search"
      >
        <!-- header -->
        <template
            v-for="(h, index) in computedHeaders"
            v-slot:[`header.${h.value}`]="{ computedHeaders }"
        >
          <span class="team-w-mg" :key="h.text" v-if="h.img">
            <span>{{ h.text }}</span>
            <v-avatar size="20"> <img :src="h.img"/></v-avatar>
          </span>

          <span class="team-w-mg" v-else :key="index">{{ h.text }}</span>
        </template>
        <!-- header -->

        <!-- date -->
        <template v-slot:item.DateTime="{ item }">
          <p>{{ item.DateTime | DatetimeFormat }}</p>
        </template>

        <!--//* matchup -->
        <template v-slot:item.Game="{ item }">
          <p class="body-2" v-if="item.HomeOrAway == 'HOME'">
            {{ item.Opponent }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Team }}
            </span>
          </p>

          <p class="body-2" v-if="item.HomeOrAway == 'AWAY'">
            {{ item.Team }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Opponent }}
            </span>
          </p>
        </template>
        <!--//* matchup ends -->

        <template v-slot:item.ProfilePic="{ item }">
          <!-- //* avatar -->

          <v-avatar width="35" height="40">
            <img :src="item.ProfilePic"/>
          </v-avatar>
          <!-- <span>{{ item.Name }}</span> -->
          <!-- //* avatar ends-->
        </template>

        <!-- fantasy points -->
        <template v-slot:item.CalFantasyPoints="{ item }">
          <p v-if="item.CalFantasyPoints == ''">_</p>
          <p v-else>{{ parseFloat(item.CalFantasyPoints).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceFantasyPoints="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalFantasyPoints) >= 0 &&
              parseFloat(item.CalFantasyPoints) < 10
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) >= 10.1 &&
              parseFloat(item.CalFantasyPoints) <= 25
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalFantasyPoints) >= 25"
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) < 0 &&
              parseFloat(item.CalFantasyPoints) >= -10
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) <= -10.1 &&
              parseFloat(item.CalFantasyPoints) >= -25
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) < -25 &&
              parseFloat(item.CalFantasyPoints) >= -100
            "
          >
            Under
          </p>
        </template>

        <!-- assist points -->

        <template v-slot:item.CalAssists="{ item }">
          <p v-if="item.CalAssists == ''">_</p>
          <p v-else>{{ parseFloat(item.CalAssists).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceAssists="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalAssists) >= 0 &&
              parseFloat(item.CalAssists) < 10
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalAssists) >= 10.1 &&
              parseFloat(item.CalAssists) <= 25
            "
          >
            Over
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalAssists) >= 25">
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalAssists) < 0 &&
              parseFloat(item.CalAssists) >= -10
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalAssists) <= -10.1 &&
              parseFloat(item.CalAssists) >= -25
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalAssists) < -25 &&
              parseFloat(item.CalAssists) >= -100
            "
          >
            Under
          </p>
        </template>

        <!-- confidenceRounds -->

        <template v-slot:item.CalRebounds="{ item }">
          <p v-if="item.CalRebounds == ''">_</p>
          <p v-else>{{ parseFloat(item.CalRebounds).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceRounds="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalRebounds) >= 0 &&
              parseFloat(item.CalRebounds) < 10
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalRebounds) >= 10.1 &&
              parseFloat(item.CalRebounds) <= 25
            "
          >
            Over
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalRebounds) >= 25">
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalRebounds) < 0 &&
              parseFloat(item.CalRebounds) >= -10
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalRebounds) <= -10.1 &&
              parseFloat(item.CalRebounds) >= -25
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalRebounds) < -25 &&
              parseFloat(item.CalRebounds) >= -100
            "
          >
            Under
          </p>
        </template>

        <!-- points -->

        <template v-slot:item.CalPoints="{ item }">
          <p v-if="item.CalPoints == ''">_</p>
          <p v-else>{{ parseFloat(item.CalPoints).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidencePoints="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalPoints) >= 0 && parseFloat(item.CalPoints) < 10
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPoints) >= 10.1 &&
              parseFloat(item.CalPoints) <= 25
            "
          >
            Over
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalPoints) >= 25">
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalPoints) < 0 &&
              parseFloat(item.CalPoints) >= -10
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPoints) <= -10.1 &&
              parseFloat(item.CalPoints) >= -25
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalPoints) < -25 &&
              parseFloat(item.CalPoints) >= -100
            "
          >
            Under
          </p>
        </template>

        <!-- FG made -->

        <template v-slot:item.CalFieldGoalsMade="{ item }">
          <p v-if="item.CalFieldGoalsMade == ''">_</p>
          <p v-else>{{ parseFloat(item.CalFieldGoalsMade).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceFgMade="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalFieldGoalsMade) >= 0 &&
              parseFloat(item.CalFieldGoalsMade) < 10
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFieldGoalsMade) >= 10.1 &&
              parseFloat(item.CalFieldGoalsMade) <= 25
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalFieldGoalsMade) >= 25"
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalFieldGoalsMade) < 0 &&
              parseFloat(item.CalFieldGoalsMade) >= -10
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFieldGoalsMade) <= -10.1 &&
              parseFloat(item.CalFieldGoalsMade) >= -25
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalFieldGoalsMade) < -25 &&
              parseFloat(item.CalFieldGoalsMade) >= -100
            "
          >
            Under
          </p>
        </template>

        <!-- FG Att -->
        <template v-slot:item.CalFieldGoalsAttempted="{ item }">
          <p v-if="item.CalFieldGoalsAttempted == ''">_</p>
          <p v-else>
            {{ parseFloat(item.CalFieldGoalsAttempted).toFixed(2) }}%
          </p>
        </template>

        <template v-slot:item.confidenceFgAtt="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalFieldGoalsAttempted) >= 0 &&
              parseFloat(item.CalFieldGoalsAttempted) < 10
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFieldGoalsAttempted) >= 10.1 &&
              parseFloat(item.CalFieldGoalsAttempted) <= 25
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalFieldGoalsAttempted) >= 25"
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalFieldGoalsAttempted) < 0 &&
              parseFloat(item.CalFieldGoalsAttempted) >= -10
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFieldGoalsAttempted) <= -10.1 &&
              parseFloat(item.CalFieldGoalsAttempted) >= -25
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalFieldGoalsAttempted) < -25 &&
              parseFloat(item.CalFieldGoalsAttempted) >= -100
            "
          >
            Under
          </p>
        </template>

        <!-- 3 pointer made -->

        <template v-slot:item.CalThreePointersMade="{ item }">
          <p v-if="item.CalThreePointersMade == ''">_</p>
          <p v-else>{{ parseFloat(item.CalThreePointersMade).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceThreePoint="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalThreePointersMade) >= 0 &&
              parseFloat(item.CalThreePointersMade) < 10
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalThreePointersMade) >= 10.1 &&
              parseFloat(item.CalThreePointersMade) <= 25
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalThreePointersMade) >= 25"
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalThreePointersMade) < 0 &&
              parseFloat(item.CalThreePointersMade) >= -10
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalThreePointersMade) <= -10.1 &&
              parseFloat(item.CalThreePointersMade) >= -25
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalThreePointersMade) < -25 &&
              parseFloat(item.CalThreePointersMade) >= -100
            "
          >
            Under
          </p>
        </template>

        <!-- 3 pointer Att -->
        <template v-slot:item.CalThreePointersAttempted="{ item }">
          <p v-if="item.CalThreePointersAttempted == ''">_</p>
          <p v-else>
            {{ parseFloat(item.CalThreePointersAttempted).toFixed(2) }}%
          </p>
        </template>

        <template v-slot:item.confidenceThreePointAtt="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalThreePointersAttempted) >= 0 &&
              parseFloat(item.CalThreePointersAttempted) < 10
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalThreePointersAttempted) >= 10.1 &&
              parseFloat(item.CalThreePointersAttempted) <= 25
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalThreePointersAttempted) >= 25"
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalThreePointersAttempted) < 0 &&
              parseFloat(item.CalThreePointersAttempted) >= -10
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalThreePointersAttempted) <= -10.1 &&
              parseFloat(item.CalThreePointersAttempted) >= -25
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalThreePointersAttempted) < -25 &&
              parseFloat(item.CalThreePointersAttempted) >= -100
            "
          >
            Under
          </p>
        </template>

        <!-- steal-->
        <template v-slot:item.CalSteals="{ item }">
          <p v-if="item.CalSteals == ''">_</p>
          <p v-else>{{ parseFloat(item.CalSteals).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceSteals="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalSteals) >= 0 && parseFloat(item.CalSteals) < 10
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalSteals) >= 10.1 &&
              parseFloat(item.CalSteals) <= 25
            "
          >
            Over
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalSteals) >= 25">
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalSteals) < 0 &&
              parseFloat(item.CalSteals) >= -10.9
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalSteals) <= -10.1 &&
              parseFloat(item.CalSteals) >= -25
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalSteals) < -25 &&
              parseFloat(item.CalSteals) >= -100
            "
          >
            Under
          </p>
        </template>
      </v-data-table>

      <!-- Free user paywall -->
      <div v-if="isFreeUser" class="paywall-wrapper">
        <div class="ghost-rows" aria-hidden="true">
          <div v-for="i in 8" :key="'ghost-' + i" class="ghost-row">
            <div class="ghost-cell ghost-avatar"></div>
            <div class="ghost-cell ghost-name"></div>
            <div class="ghost-cell ghost-short"></div>
            <div class="ghost-cell ghost-medium"></div>
            <div class="ghost-cell ghost-short"></div>
            <div class="ghost-cell ghost-medium"></div>
            <div class="ghost-cell ghost-short"></div>
          </div>
        </div>
        <div class="paywall-cta">
          <v-icon size="40" color="white">mdi-lock-outline</v-icon>
          <p class="white--text text-h6 font-weight-bold mt-2 mb-1">
            Subscribe to unlock all player projections
          </p>
          <p class="grey--text text--lighten-1 body-2 mb-4">
            Free plan shows the top 5 rows only
          </p>
          <v-btn large color="#73c604" class="white--text" @click="goToUpgrade">
            Upgrade Now
          </v-btn>
        </div>
      </div>
      <!-- paywall ends -->
    </v-card>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "NbaProjection",
  data() {
    return {
      switch1: true,
      search: "",
      header: [
        {
          text: "",
          value: "ProfilePic",
          sortable: false,
        },

        {
          text: "Player Name",
          width: "150",
          value: "Name",
        },
        {
          text: "Team",
          value: "Team",
        },
        {
          text: "Opp",
          value: "Game",
          width: "110",
          align: "center",
        },

        {
          text: "Date",
          value: "DateTime",
          width: "150",
        },

        // *
        // {
        //   text: "Fantasy Points",
        //   value: "FantasyFantasyPoints",
        //   // width: '140',
        //   img: "/favicon.ico",
        //   class: "black--text",
        // },
        //
        // {
        //   text: "O/U",
        //   value: "MonkeyFantasyPoints",
        //   //img: '/img/monkeyKnife.jpeg',
        //   class: "black--text",
        // },
        //
        // {
        //   text: "% Diff",
        //   value: "CalFantasyPoints",
        //   class: "black--text",
        // },
        // {
        //   text: "Confidence",
        //   sortable: false,
        //   width: "130",
        //   value: "confidenceFantasyPoints",
        //   class: "black--text",
        // },
        // *

        {
          text: "Points",
          value: "FantasyPoints",
          img: "/favicon.ico",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyPoints",
          class: "black--text",
          //img: '/img/monkeyKnife.jpeg',
        },

        {
          text: "% Diff",
          value: "CalPoints",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          sortable: false,
          value: "confidencePoints",
          width: "130",
          class: "black--text",
        },

        // *
        // {
        //   text: "FG Made",
        //   value: "FantasyFieldGoalsMade",
        //   width: "120",
        //   img: "/favicon.ico",
        // },
        //
        // {
        //   text: "O/U",
        //   value: "MonkeyFieldGoalsMade",
        //   //img: '/img/monkeyKnife.jpeg',
        // },
        //
        // {
        //   text: "% Diff",
        //   value: "CalFieldGoalsMade",
        //   width: "110",
        // },
        //
        // {
        //   text: "Confidence",
        //   sortable: false,
        //   value: "confidenceFgMade",
        //   width: "120",
        // },

        // *
        // {
        //   text: "FG Att",
        //   value: "FantasyFieldGoalsAttempted",
        //   width: "120",
        //
        //   img: "/favicon.ico",
        // },
        //
        // {
        //   text: "O/U",
        //   value: "MonkeyFieldGoalsAttempted",
        //
        //   //img: '/img/monkeyKnife.jpeg',
        // },

        // {
        //   text: "% Diff",
        //   value: "CalFieldGoalsAttempted",
        //   width: "110",
        // },
        //
        // {
        //   text: "Confidence",
        //   sortable: false,
        //   value: "confidenceFgAtt",
        //   width: "130",
        // },

        // *
        // {
        //   text: "3 Points Made",
        //   value: "FantasyThreePointersMade",
        //   img: "/favicon.ico",
        //   // width: '120',
        //   class: "black--text",
        // },
        //
        // {
        //   text: "O/U",
        //   value: "MonkeyThreePointersMade",
        //   //img: '/img/monkeyKnife.jpeg',
        //   class: "black--text",
        // },
        //
        // {
        //   text: "% Diff",
        //   value: "CalThreePointersMade",
        //   width: "120",
        //   class: "black--text",
        // },
        //
        // {
        //   text: "Confidence",
        //   sortable: false,
        //   value: "confidenceThreePoint",
        //   width: "120",
        //   class: "black--text",
        // },

        // *
        // {
        //   text: "3 Points Att",
        //   value: "FantasyThreePointersAttempted",
        //   // width: '110',
        //   img: "/favicon.ico",
        // },
        //
        // {
        //   text: "O/U",
        //   value: "MonkeyThreePointersAttempted",
        //   //img: '/img/monkeyKnife.jpeg',
        // },
        //
        // {
        //   text: "% Diff",
        //   value: "CalThreePointersAttempted",
        //   width: "110",
        // },
        //
        // {
        //   text: "Confidence",
        //   sortable: false,
        //   value: "confidenceThreePointAtt",
        //   width: "120",
        // },

        // *
        {
          text: "Assists",
          value: "FantasyAssists",
          img: "/favicon.ico",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyAssists",
          //img: '/img/monkeyKnife.jpeg',
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalAssists",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          sortable: false,
          value: "confidenceAssists",
          width: "130",
          class: "black--text",
        },

        // *
        {
          text: "Steals",
          value: "FantasySteals",
          img: "/favicon.ico",
        },

        {
          text: "O/U",
          value: "MonkeySteals",
          //img: '/img/monkeyKnife.jpeg',
        },

        {
          text: "% Diff",
          value: "CalSteals",
          width: "110",
        },

        {
          text: "Confidence",
          sortable: false,
          value: "confidenceSteals",
          width: "130",
        },

        // *
        {
          text: "Rebounds",
          value: "FantasyRebounds",
          img: "/favicon.ico",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyRebounds",
          //img: '/img/monkeyKnife.jpeg',
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalRebounds",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidenceRounds",
          sortable: false,
          width: "130",
          class: "black--text",
        },
      ],
    };
  },

  computed: {
    ...mapState("NbaModule", ["nba_props"]),
    ...mapState("userModule", ["userState"]),

    isFreeUser() {
      const planType = localStorage.getItem('planType');
      return planType === 'Free' || (this.userState && this.userState.plantype === 'Free');
    },

    projectionItems() {
      const items = this.nba_props.teams || [];
      return this.isFreeUser ? items.slice(0, 5) : items;
    },

    computedHeaders() {
      if (this.switch1) {
        return this.header;
      } else if (!this.switch1) {
        let newHeader = this.header.filter((column) => {
          return (
              !column.value.includes("MonkeyFantasyPoints") &&
              !column.value.includes("CalFantasyPoints") &&
              !column.value.includes("confidenceFantasyPoints") &&
              !column.value.includes("MonkeyPoints") &&
              !column.value.includes("CalPoints") &&
              !column.value.includes("confidencePoints") &&
              !column.value.includes("MonkeyFieldGoalsMade") &&
              !column.value.includes("CalFieldGoalsMade") &&
              !column.value.includes("confidenceFgMade") &&
              !column.value.includes("MonkeyFieldGoalsAttempted") &&
              !column.value.includes("CalFieldGoalsAttempted") &&
              !column.value.includes("confidenceFgAtt") &&
              !column.value.includes("MonkeyThreePointersMade") &&
              !column.value.includes("CalThreePointersMade") &&
              !column.value.includes("confidenceThreePoint") &&
              !column.value.includes("MonkeyThreePointersAttempted") &&
              !column.value.includes("CalThreePointersAttempted") &&
              !column.value.includes("confidenceThreePointAtt") &&
              !column.value.includes("MonkeyAssists") &&
              !column.value.includes("CalAssists") &&
              !column.value.includes("confidenceAssists") &&
              !column.value.includes("MonkeySteals") &&
              !column.value.includes("CalSteals") &&
              !column.value.includes("confidenceSteals") &&
              !column.value.includes("MonkeyRebounds") &&
              !column.value.includes("CalRebounds") &&
              !column.value.includes("confidenceRounds")
          );
        });
        return newHeader;
      }
    },
  },

  created() {
    this.fetchNbaPropsData();
  },


  methods: {
    fetchNbaPropsData() {
      this.$store.dispatch("NbaModule/getNbaProps");
    },

    goBack() {
      this.$router.go(-1);
    },

    goToUpgrade() {
      this.$router.push({name: "upgradePlan"});
    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table
>>> .v-data-table__wrapper
> table
> thead
> tr:last-child
> th {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

span.team-w-mg {
  /* display: flex !important; */
  float: left !important;
}

.theme--light.v-data-table
>>> .v-data-table__wrapper
> table
> thead
> tr:last-child
> th.black--text {
  background-color: #cfd8dc !important;
}

.projection-table >>> .v-data-table-header__icon {
  opacity: 1;
}

.light-green {
  background-clip: #99cc99;
  padding: 5px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-weight: 800;
}

.medium-green {
  background-color: #33cc66;
  padding: 5px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-weight: 800;
}

.dark-green {
  background-color: #336633;
  padding: 5px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-weight: 800;
}

.paywall-wrapper {
  position: relative;
  overflow: hidden;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.ghost-rows {
  filter: blur(5px);
  pointer-events: none;
  user-select: none;
}

.ghost-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  gap: 20px;
}

.ghost-cell {
  background: #e0e0e0;
  border-radius: 4px;
  height: 14px;
  flex-shrink: 0;
}

.ghost-avatar { width: 36px; height: 36px; border-radius: 50%; }
.ghost-name   { width: 110px; }
.ghost-short  { width: 50px; }
.ghost-medium { width: 80px; }

.paywall-cta {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.72);
  padding: 24px;
  text-align: center;
}
</style>
